import React, { useState } from 'react';
export type StatusType = 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'processing';
interface StatusBadgeProps {
  status: StatusType;
  children: React.ReactNode;
  className?: string;
  tooltip?: string;
}
export function StatusBadge({
  status,
  children,
  className = '',
  tooltip
}: StatusBadgeProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  const styles = {
    success: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    warning: 'bg-amber-100 text-amber-700 border-amber-200',
    error: 'bg-rose-100 text-rose-700 border-rose-200',
    info: 'bg-blue-100 text-blue-700 border-blue-200',
    neutral: 'bg-slate-100 text-slate-700 border-slate-200',
    processing: 'bg-indigo-100 text-indigo-700 border-indigo-200'
  };
  return <span className="relative inline-flex" data-id="element-97">
      <span onMouseEnter={() => tooltip && setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} className={`${`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles[status]} ${className}`} text-[10px] font-[500] pl-[10px] pr-[10px] ${tooltip ? 'cursor-help' : ''}`} data-id="element-98">
        {children}
      </span>
      {tooltip && showTooltip && <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 w-56 rounded-lg bg-slate-800 text-white text-xs px-3 py-2 shadow-lg leading-relaxed pointer-events-none" data-id="element-99">
          {tooltip}
          <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-800" data-id="element-100" />
        </span>}
    </span>;
}